import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ResponseGeneraAssociazioneStudenteGruppoDTO,
  ListSelectDTO,
} from 'src/app/model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  AddUpdateRegistrazioneSistemaCommand,
  GetCommand,
  SelectCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class AFunzionalitaService {
  constructor(private http: HttpClient) {}

  attivaDisattivaRegistrazioneSistema(registrazioneSistema: boolean) {
    const command = new AddUpdateRegistrazioneSistemaCommand();
    command.id = 1;
    command.attiva = registrazioneSistema;
    return this.http.post<Boolean>(
      ConstantsCLA.SAVE_REGISTRAZIONE_SISTEMA_URL,
      command
    );
  }

  generaGruppiStudio() {
    const command = new GetCommand();
    command.id = -1;
    return this.http.post<ResponseGeneraAssociazioneStudenteGruppoDTO>(
      ConstantsCLA.GENERA_GRUPPI_STUDIO_URL,
      command
    );
  }

  selectProveFinali() {
    const command = new SelectCommand();

    return this.http.post<ListSelectDTO>(
      ConstantsCLA.PROVE_FINALI_COMBO_URL,
      command
    );
  }

  downloadAmmessi(idProvaFinale: number) {
    const command = new GetCommand();
    command.id = idProvaFinale;
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({}),
    };

    return this.http.post<any>(
      ConstantsCLA.SCARICA_AMMESSI_URL,
      command,
      httpOptions
    );
  }

  downloadStudentiPlacement() {
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({}),
    };
    const command = new GetCommand();

    return this.http.post<any>(
      ConstantsCLA.DOWNLOAD_STUDENTI_PLACEMENT,
      command,
      httpOptions
    );
  }
}
